<template>
  <ServicePageLayout
    icon="fas fa-clinic-medical"
    title="Health Services"
    subtitle="Comprehensive healthcare support for the campus community"
  >
    <section class="content-section">
      <h2>
        <i class="fas fa-info-circle section-icon" />
        Overview
      </h2>
      <p>
        The Campus Health Center provides accessible healthcare services to all enrolled students.
        Our medical team is committed to promoting wellness, preventing illness, and providing
        quality care for the campus community.
      </p>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-stethoscope section-icon" />
        Medical Services
      </h2>
      <div class="services-grid">
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-user-md" />
          </div>
          <h3>General Consultation</h3>
          <p>Medical check-ups, diagnosis, and treatment for common illnesses.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-first-aid" />
          </div>
          <h3>First Aid</h3>
          <p>Emergency first aid treatment and basic wound care.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-syringe" />
          </div>
          <h3>Immunization</h3>
          <p>Vaccination services and immunization records management.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-heartbeat" />
          </div>
          <h3>Vital Signs Check</h3>
          <p>Blood pressure, temperature, and other vital signs monitoring.</p>
        </div>
        <div class="service-card">
          <div class="card-icon green">
            <i class="fas fa-pills" />
          </div>
          <h3>Medicine Dispensary</h3>
          <p>Basic over-the-counter medications for common ailments.</p>
        </div>
        <div class="service-card">
          <div class="card-icon yellow">
            <i class="fas fa-file-medical" />
          </div>
          <h3>Medical Certificates</h3>
          <p>Issuance of medical certificates and health clearances.</p>
        </div>
      </div>
    </section>

    <section class="content-section highlight">
      <div class="highlight-content">
        <div class="highlight-icon">
          <i class="fas fa-brain" />
        </div>
        <div class="highlight-text">
          <h3>Mental Health Support</h3>
          <p>
            We understand the importance of mental wellness. Our clinic offers referrals
            to professional counselors and mental health resources. If you're feeling
            overwhelmed, anxious, or stressed, please don't hesitate to reach out.
          </p>
          <router-link
            to="/services/counseling"
            class="highlight-link"
          >
            Visit Counseling Services
            <i class="fas fa-arrow-right" />
          </router-link>
        </div>
      </div>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-calendar-alt section-icon" />
        Clinic Hours
      </h2>
      <div class="schedule-card">
        <div class="schedule-row">
          <span class="day">Monday - Friday</span>
          <span class="time">7:30 AM - 5:30 PM</span>
        </div>
        <div class="schedule-row">
          <span class="day">Saturday</span>
          <span class="time">8:00 AM - 12:00 PM</span>
        </div>
        <div class="schedule-row">
          <span class="day">Sunday & Holidays</span>
          <span class="time">Emergency Only</span>
        </div>
      </div>
      <p class="schedule-note">
        <i class="fas fa-exclamation-circle" />
        For emergencies outside clinic hours, please proceed to the nearest hospital.
      </p>
    </section>

    <section class="content-section">
      <h2>
        <i class="fas fa-phone section-icon" />
        Contact Information
      </h2>
      <div class="contact-info">
        <div class="contact-item">
          <i class="fas fa-map-marker-alt" />
          <span>Ground Floor, Student Services Building</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-phone" />
          <span>(078) 123-4567 Local 100</span>
        </div>
        <div class="contact-item emergency">
          <i class="fas fa-ambulance" />
          <span>Emergency Hotline: (078) 123-4599</span>
        </div>
        <div class="contact-item">
          <i class="fas fa-envelope" />
          <span>clinic@nec.edu.ph</span>
        </div>
      </div>
    </section>

    <section class="cta-section">
      <h2>Need Medical Assistance?</h2>
      <p>Schedule a consultation or walk in during clinic hours.</p>
      <button
        class="cta-button"
        @click="scheduleAppointment"
      >
        <i class="fas fa-calendar-plus" />
        Schedule Visit
      </button>
    </section>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/landing/ServicePageLayout.vue'

export default {
  name: 'HealthService',

  components: {
    ServicePageLayout
  },

  metaInfo: () => ({
    title: 'Health Services'
  }),

  methods: {
    scheduleAppointment () {
      this.$bvToast.toast('Appointment scheduling coming soon!', {
        title: 'Coming Soon',
        variant: 'info',
        solid: true
      })
    }
  }
}
</script>
